import * as React from 'react';
import { SegmentRatioBar } from '../../../designSystem/graphs/SegmentRatioBar';
import { SelectionSummary } from '../../../amorg-common';
import { colors } from '../../../designSystem/colors/color';
import { getAnswerRationGraphValueText } from './AnswerRatioBarGraph';

type GroupedAnswerRatioBarGraphProps = {
    data:SelectionSummary,
    legend: 'none' |'regular' | 'classic',
    heightPx?:number,
    showValueText?:boolean
}
export function GroupedAnswerRatioBarGraph(props:GroupedAnswerRatioBarGraphProps):JSX.Element
{
    const totalSelections = props.data.value1Count + props.data.value2Count + props.data.value3Count + props.data.value4Count + props.data.value5Count;

    return (
        <SegmentRatioBar legend={props.legend} heightPx={props.heightPx} showValueText={props.showValueText}
            data={[
                { 
                    value:props.data.value1Count + props.data.value2Count, 
                    color:colors.graphs.survey.groupedAnswers.unfavorable,
                    legendText: `Uenig eller meget uenig ${((props.data.value1Count + props.data.value2Count)/totalSelections*100).toFixed(1)}%`,
                    valueText:getAnswerRationGraphValueText(props.data.value1Count + props.data.value2Count, totalSelections)
                },
                { 
                    value:props.data.value3Count, 
                    color:colors.graphs.survey.groupedAnswers.neutral,
                    legendText: `Neutral ${(props.data.value3Count/totalSelections*100).toFixed(1)}%`,
                    valueText:getAnswerRationGraphValueText(props.data.value3Count, totalSelections)
                },
                { 
                    value:props.data.value4Count + props.data.value5Count, 
                    color:colors.graphs.survey.groupedAnswers.favorable,
                    legendText: `Enig eller meget enig ${((props.data.value4Count + props.data.value5Count)/totalSelections*100).toFixed(1)}%`,
                    valueText:getAnswerRationGraphValueText(props.data.value4Count + props.data.value5Count, totalSelections)
                },
        ]}/>
    );
}